/**
 * @file: dateRangeTillLastWorkday.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { DateRange } from '@euler/model/common';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import { latestWorkday } from './latestWorkday';

export function dateRangeTillLastWorkday(offset: number): DateRange {
  return {
    startDate: format(addDays(latestWorkday(), -offset), 'yyyy-MM-dd'),
    startInclusive: true,
  };
}
